export default __webpack_public_path__ + "static/media/ic_user_active.a713bc98.svg";